import cn from "classnames";
import styles from "./Tabs.module.scss";

type TabsRowProps = {
  className?: string;
};

export const TabsRow: RFC<TabsRowProps> = ({ className, children }) => {
  return <div className={cn(styles.row, className)}>{children}</div>;
};
